import React from "react";
import {
    IhioPrescriptionAdmissionType,
    IhioWrittenPrescriptionInfoType, IhioWrittenPrescriptionItemType
} from "../../../../../types/ihioPrescriptionFilling";
import BoxLoader from "../../../general/boxLoader";
import EmptyBox from "../../../general/emptyBox";
import PrescriptionItemsToFulfilRowItem from "./prescriptionItemsToFulfilRowItem";

type PrescriptionItemsToFulfilProps = {
    prescriptionAdmissionData: IhioPrescriptionAdmissionType;
    writtenPrescriptionData: IhioWrittenPrescriptionInfoType | null;
    itemsToFulfil: Record<string, IhioWrittenPrescriptionItemType>;
    handleRemoveItemFromFulfil: (UUID: string) => void;
    handleUpdateRowItem: (UUID: string, item: IhioWrittenPrescriptionItemType, itemCount: number) => Promise<number | undefined>;
    isLoading: boolean;
}

const PrescriptionItemsToFulfil = ({
    prescriptionAdmissionData,
    writtenPrescriptionData,
    itemsToFulfil,
    handleRemoveItemFromFulfil,
    handleUpdateRowItem,
    isLoading
}: PrescriptionItemsToFulfilProps) => {

    return(
        <>
            <div className={'w-100 rounded rounded-4 border bg-white mt-3 py-2 px-4'}>
                {isLoading && (
                    <BoxLoader type="cover" />
                )}
                <div className={'d-flex align-items-center justify-content-between'}>
                    <div className='fs-5 tw-font-[600]'>
                        خدمات قابل ارائه
                    </div>
                </div>
                <div className={'mt-3 d-flex flex-column gap-2'}>
                    {Object.keys(itemsToFulfil)?.length > 0 ? (
                        <>
                            {Object.keys(itemsToFulfil)?.map(UUID => {
                                return(
                                    <PrescriptionItemsToFulfilRowItem
                                        key={UUID}
                                        item={itemsToFulfil[UUID]}
                                        handleRemoveItemFromFulfil={handleRemoveItemFromFulfil}
                                        handleUpdateRowItem={handleUpdateRowItem}
                                    />
                                )
                            })}
                        </>
                    ) : (
                        <div
                            className={'w-100 gap-3 d-flex align-items-center justify-content-center flex-column'}>
                            <EmptyBox/>
                            <span className="tw-font-bold">خدمتی جهت ارائه یافت نشد</span>
                        </div>
                    )}

                </div>
            </div>
        </>
    )
}


export default PrescriptionItemsToFulfil;